import { useMediaQuery } from 'src/common/hooks/useMediaQuery';
import { getAppbarCompactMediaQuery } from '../layout';

/** True when viewport is below the compact appbar breakpoint. */
export function useCompactAppbar(): boolean {
  return !useMediaQuery(getAppbarCompactMediaQuery());
}
